import { defineComponent as _defineComponent } from 'vue'
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import Icon from 'JS/components/Icon.vue';
import { BCheckbox } from 'JS/components/blain-form';
import { computed, ref }  from 'vue';
import { IWarranty } from 'JS/types/Product';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompactWarrantyOption',
  props: {
    warranty: null,
    selected: { type: Boolean },
    showErrorMessage: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'select'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	warranty: IWarranty,
	selected: boolean,
	showErrorMessage: boolean
}





const errorMessage = computed<string>(() =>
	props.selected
		? "<span class='bold'>Failed to remove warranty.</span> Please try again."
		: "<span class='bold'>Failed to add warranty.</span> Please try again.");


return { __sfc: true,props, emit, errorMessage, ErrorBanner, Icon, BCheckbox }
}

})